import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    circular: {
        marginRight: spacing(1),
    },
}));
//# sourceMappingURL=ui_chip.css.js.map